import { Suspense, lazy, useMemo } from "react";
import { jsx } from "react/jsx-runtime";
import { SuspenseFallback } from "@tecnobit-srl/components-store";
//#region src/use-grid.tsx
var LazyGrid = lazy(() => import("./grid-DreEgNUk.js").then((n) => n.n).then((module) => ({ default: module.Grid })));
function Grid({ ...props }) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "grid" }),
		children: /* @__PURE__ */ jsx(LazyGrid, { ...props })
	});
}
function GridContent({ ...props }) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "grid" }),
		children: /* @__PURE__ */ jsx(LazyGrid, { ...props })
	});
}
var useGridContent = () => {
	return useMemo(() => ({ grid: { component: GridContent } }), []);
};
//#endregion
export { Grid, useGridContent };
